import React from 'react';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <section className="w-full bg-white py-12 md:py-20 px-4" data-id="element-174">
      <div className="max-w-[680px] mx-auto" data-id="element-175">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-dark-gray text-center mb-10" data-id="element-176">
          🎁 Todo lo que Recibís Hoy:
        </h2>

        {/* Checklist */}
        <div className="space-y-4 mb-10" data-id="element-177">
          <div className="flex items-start gap-3 font-body" data-id="element-178">
            <span className="text-green-500 flex-shrink-0 mt-0.5" data-id="element-179">✅</span>
            <p className="text-dark-gray" data-id="element-180">
              <span className="font-bold" data-id="element-181">
                Ebook completo — Bikinis al Crochet: +60 Piezas Únicas
              </span>{' '}
              <span className="text-medium-gray" data-id="element-182">| Valor $47</span>
            </p>
          </div>
          <div className="flex items-start gap-3 font-body" data-id="element-183">
            <span className="text-green-500 flex-shrink-0 mt-0.5" data-id="element-184">✅</span>
            <p className="text-dark-gray" data-id="element-185">
              <span className="font-bold" data-id="element-186">
                Patrones de principiante a avanzado organizados por nivel
              </span>{' '}
              <span className="text-medium-gray" data-id="element-187">| incluido</span>
            </p>
          </div>
          <div className="flex items-start gap-3 font-body" data-id="element-188">
            <span className="text-green-500 flex-shrink-0 mt-0.5" data-id="element-189">✅</span>
            <p className="text-dark-gray" data-id="element-190">
              <span className="font-bold" data-id="element-191">
                Guía de ajuste de talle para cada tipo de cuerpo
              </span>{' '}
              <span className="text-medium-gray" data-id="element-192">| incluido</span>
            </p>
          </div>
          <div className="flex items-start gap-3 font-body" data-id="element-193">
            <span className="text-green-500 flex-shrink-0 mt-0.5" data-id="element-194">✅</span>
            <p className="text-dark-gray" data-id="element-195">
              <span className="font-bold" data-id="element-196">
                Guía de materiales con desglose de costos
              </span>{' '}
              <span className="text-medium-gray" data-id="element-197">| incluido</span>
            </p>
          </div>
          <div className="flex items-start gap-3 font-body" data-id="element-198">
            <span className="text-green-500 flex-shrink-0 mt-0.5" data-id="element-199">✅</span>
            <p className="text-dark-gray" data-id="element-200">
              <span className="font-bold" data-id="element-201">
                Hoja de referencia de símbolos y abreviaturas
              </span>{' '}
              <span className="text-medium-gray" data-id="element-202">| incluido</span>
            </p>
          </div>
          <div className="flex items-start gap-3 font-body" data-id="element-203">
            <span className="text-green-500 flex-shrink-0 mt-0.5" data-id="element-204">✅</span>
            <p className="text-dark-gray" data-id="element-205">
              <span className="font-bold" data-id="element-206">Entrega inmediata a tu email</span>{' '}
              <span className="text-medium-gray" data-id="element-207">| incluido</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}